import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { TokenGuard } from './guards/token.guard';
import { tabLimitGuard } from './guards/tab-limit.guard';

export const rootRouterConfig: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [tabLimitGuard],
    loadComponent: () =>
      import('./shared/components/layouts/admin-layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./shared/components/layouts/admin-layout/home-tab.component').then((m) => m.HomeTabComponent),
      },
      {
        path: 'accidentes-personales',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/accidentes-personales.routes').then((m) => m.AccidentesPersonalesRoutes),
      },
      {
        path: 'cobranzas',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/cobranzas.routes').then((m) => m.CobranzasRoutes),
      },
      {
        path: 'contabilidad',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/contabilidad.routes').then((m) => m.ContabilidadRoutes),
      },
      {
        path: 'cotizadores',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/cotizadores.routes').then((m) => m.CotizadoresRoutes),
      },
      {
        path: 'comercial',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/comercial.routes').then((m) => m.ComercialRoutes),
      },
      {
        path: 'cumplimiento',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/cumplimiento.routes').then((m) => m.CumplimientoRoutes),
      },
      {
        path: 'indemnizaciones',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/indemnizaciones.routes').then((m) => m.IndemnizacionesRoutes),
      },
      {
        path: 'index',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/index.routes').then((m) => m.IndexRoutes),
      },
      {
        path: 'salvamentos',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/salvamentos.routes').then((m) => m.SalvamentosRoutes),
      },
      {
        path: 'seguridad',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/seguridad.routes').then((m) => m.SeguridadRoutes),
      },
      {
        path: 'sistema',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/sistema.routes').then((m) => m.SistemaRoutes),
      },
      {
        path: 'reportes',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/reportes.routes').then((m) => m.ReportesRoutes),
      },
      {
        path: 'administrativo',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/administrativo.routes').then((m) => m.AdministrativoRoutes),
      },
      {
        path: 'transporte',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/transporte.routes').then((m) => m.TransporteRoutes),
      },
      {
        path: 'emision',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/emision-routes').then((m) => m.EmisionRoutes),
      },
      {
        path: 'fianza',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/fianza.routes').then((m) => m.FianzaRoutes),
      },
    ],
  },
  {
    path: 'tmp-preview-usuarios',
    loadComponent: () =>
      import('./components/seguridad/gestionusuariosaccesos/usuario/usuario.component').then((m) => m.UsuarioComponent),
  },
  {
    path: 'cotizador',
    loadComponent: () => import('./components/public/cotizador/cotizador.component').then((m) => m.CotizadorComponent),
  },
  {
    path: 'fianzas',
    loadChildren: () => import('./routes/fianzas.routes').then((m) => m.FianzasRoutes),
  },
  {
    path: 'cot-pymes',
    canActivate: [TokenGuard],
    data: { expectedUsuario: 'cotizador', redirectTo: '/cotizador' },
    loadComponent: () =>
      import('./components/public/cotizador/cot-pymes/cot-pymes.component').then((m) => m.CotPymesComponent),
  },
  {
    path: 'registro-tarjetas',
    loadComponent: () =>
      import('./components/public/cobranzas/registro-tarjetas/registro-tarjetas.component').then(
        (m) => m.RegistroTarjetasComponent,
      ),
  },
  {
    path: 'cotizacion-repuestos',
    loadComponent: () =>
      import('./components/indemnizaciones/cotizaciones/componentes/cotizador-repuestos/cotizador-repuestos.component').then(
        (m) => m.CotizadorRepuestosComponent,
      ),
  },
  {
    path: 'premios-broker',
    loadComponent: () =>
      import('./components/public/premios-broker/premios-broker.component').then((m) => m.PremiosBrokerComponent),
  },
  {
    path: 'cotizador-fianzas',
    loadComponent: () =>
      import('./components/public/cotizador-fianzas/cotizador-fianzas.component').then(
        (m) => m.CotizadorFianzasComponent,
      ),
  },
  {
    path: 'formulario-cotizador-fianzas',
    canActivate: [TokenGuard],
    data: { expectedUsuario: 'cotizadorFianzas', redirectTo: '/cotizador-fianzas' },
    loadComponent: () =>
      import('./components/public/formulario-cotizador-fianzas/formulario-cotizador-fianzas.component').then(
        (m) => m.FormularioCotizadorFianzasComponent,
      ),
  },
  {
    path: 'crear-usuario',
    loadComponent: () =>
      import('./components/public/crear-usuario/crear-usuario.component').then((m) => m.CrearUsuarioComponent),
  },
  {
    path: 'rechazar-formulario',
    loadComponent: () =>
      import('./components/public/rechazar-cotizacion/rechazar-cotizacion.component').then(
        (m) => m.RechazarCotizacionComponent,
      ),
  },
  {
    path: 'formularios-online',
    loadComponent: () =>
      import('./components/public/formularios-online/formularios-online.component').then(
        (m) => m.FormulariosOnlineComponent,
      ),
  },
  {
    path: 'formulario-taller',
    loadComponent: () =>
      import('./components/public/formulario-taller/formulario-taller.component').then(
        (m) => m.FormularioTallerComponent,
      ),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./components/public/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./components/public/not-authorized/not-authorized.component').then((m) => m.NotAuthorizedComponent),
  },
  {
    path: '**',
    loadComponent: () => import('./components/public/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
